import axios from 'axios';

export const getLaporanJurnal = async (formData) => {
    return await axios.post(`${window._HOST}admin/laporanJurnal`, formData, {withCredentials: true})
}

export const getLaporanJurnalByKodeAkun = async (formData) => {
    return await axios.post(`${window._HOST}admin/laporanJurnal/detail`, formData, {withCredentials: true})
}